export var SystemNetHttpStatusCode;
(function (SystemNetHttpStatusCode) {
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value100"] = 100] = "Value100";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value101"] = 101] = "Value101";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value102"] = 102] = "Value102";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value103"] = 103] = "Value103";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value200"] = 200] = "Value200";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value201"] = 201] = "Value201";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value202"] = 202] = "Value202";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value203"] = 203] = "Value203";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value204"] = 204] = "Value204";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value205"] = 205] = "Value205";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value206"] = 206] = "Value206";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value207"] = 207] = "Value207";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value208"] = 208] = "Value208";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value226"] = 226] = "Value226";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value300"] = 300] = "Value300";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value301"] = 301] = "Value301";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value302"] = 302] = "Value302";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value303"] = 303] = "Value303";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value304"] = 304] = "Value304";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value305"] = 305] = "Value305";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value306"] = 306] = "Value306";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value307"] = 307] = "Value307";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value308"] = 308] = "Value308";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value400"] = 400] = "Value400";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value401"] = 401] = "Value401";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value402"] = 402] = "Value402";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value403"] = 403] = "Value403";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value404"] = 404] = "Value404";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value405"] = 405] = "Value405";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value406"] = 406] = "Value406";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value407"] = 407] = "Value407";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value408"] = 408] = "Value408";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value409"] = 409] = "Value409";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value410"] = 410] = "Value410";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value411"] = 411] = "Value411";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value412"] = 412] = "Value412";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value413"] = 413] = "Value413";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value414"] = 414] = "Value414";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value415"] = 415] = "Value415";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value416"] = 416] = "Value416";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value417"] = 417] = "Value417";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value421"] = 421] = "Value421";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value422"] = 422] = "Value422";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value423"] = 423] = "Value423";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value424"] = 424] = "Value424";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value426"] = 426] = "Value426";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value428"] = 428] = "Value428";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value429"] = 429] = "Value429";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value431"] = 431] = "Value431";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value451"] = 451] = "Value451";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value500"] = 500] = "Value500";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value501"] = 501] = "Value501";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value502"] = 502] = "Value502";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value503"] = 503] = "Value503";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value504"] = 504] = "Value504";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value505"] = 505] = "Value505";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value506"] = 506] = "Value506";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value507"] = 507] = "Value507";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value508"] = 508] = "Value508";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value510"] = 510] = "Value510";
    SystemNetHttpStatusCode[SystemNetHttpStatusCode["Value511"] = 511] = "Value511";
})(SystemNetHttpStatusCode || (SystemNetHttpStatusCode = {}));
export var CommonEnumsErrorBaseCode;
(function (CommonEnumsErrorBaseCode) {
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value0"] = 0] = "Value0";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value2"] = 2] = "Value2";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value3"] = 3] = "Value3";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value4"] = 4] = "Value4";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value5"] = 5] = "Value5";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value6"] = 6] = "Value6";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value7"] = 7] = "Value7";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value8"] = 8] = "Value8";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value9"] = 9] = "Value9";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value10"] = 10] = "Value10";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value11"] = 11] = "Value11";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value12"] = 12] = "Value12";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value13"] = 13] = "Value13";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value14"] = 14] = "Value14";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value15"] = 15] = "Value15";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value17"] = 17] = "Value17";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value18"] = 18] = "Value18";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value19"] = 19] = "Value19";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value20"] = 20] = "Value20";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value21"] = 21] = "Value21";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value24"] = 24] = "Value24";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value25"] = 25] = "Value25";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value26"] = 26] = "Value26";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value27"] = 27] = "Value27";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value28"] = 28] = "Value28";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value29"] = 29] = "Value29";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value30"] = 30] = "Value30";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value33"] = 33] = "Value33";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value34"] = 34] = "Value34";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value43"] = 43] = "Value43";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value57"] = 57] = "Value57";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value61"] = 61] = "Value61";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value62"] = 62] = "Value62";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value63"] = 63] = "Value63";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value69"] = 69] = "Value69";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value71"] = 71] = "Value71";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value75"] = 75] = "Value75";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value76"] = 76] = "Value76";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value81"] = 81] = "Value81";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value84"] = 84] = "Value84";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value88"] = 88] = "Value88";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value92"] = 92] = "Value92";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value94"] = 94] = "Value94";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value95"] = 95] = "Value95";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value96"] = 96] = "Value96";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value99"] = 99] = "Value99";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value105"] = 105] = "Value105";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value108"] = 108] = "Value108";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value109"] = 109] = "Value109";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value110"] = 110] = "Value110";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value111"] = 111] = "Value111";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value112"] = 112] = "Value112";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value113"] = 113] = "Value113";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value114"] = 114] = "Value114";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value115"] = 115] = "Value115";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value116"] = 116] = "Value116";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value117"] = 117] = "Value117";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value118"] = 118] = "Value118";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value119"] = 119] = "Value119";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value120"] = 120] = "Value120";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value121"] = 121] = "Value121";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value122"] = 122] = "Value122";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value123"] = 123] = "Value123";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value124"] = 124] = "Value124";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value125"] = 125] = "Value125";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value126"] = 126] = "Value126";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value127"] = 127] = "Value127";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value128"] = 128] = "Value128";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value129"] = 129] = "Value129";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value130"] = 130] = "Value130";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value131"] = 131] = "Value131";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value132"] = 132] = "Value132";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value133"] = 133] = "Value133";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value134"] = 134] = "Value134";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value135"] = 135] = "Value135";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value136"] = 136] = "Value136";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value137"] = 137] = "Value137";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value138"] = 138] = "Value138";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value139"] = 139] = "Value139";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value140"] = 140] = "Value140";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value141"] = 141] = "Value141";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value142"] = 142] = "Value142";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value143"] = 143] = "Value143";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value144"] = 144] = "Value144";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value155"] = 155] = "Value155";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value156"] = 156] = "Value156";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value157"] = 157] = "Value157";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value158"] = 158] = "Value158";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value159"] = 159] = "Value159";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value160"] = 160] = "Value160";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value161"] = 161] = "Value161";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value162"] = 162] = "Value162";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value163"] = 163] = "Value163";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value164"] = 164] = "Value164";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value165"] = 165] = "Value165";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value166"] = 166] = "Value166";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value167"] = 167] = "Value167";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value168"] = 168] = "Value168";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value169"] = 169] = "Value169";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value170"] = 170] = "Value170";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value171"] = 171] = "Value171";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value172"] = 172] = "Value172";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value173"] = 173] = "Value173";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value174"] = 174] = "Value174";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value175"] = 175] = "Value175";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value176"] = 176] = "Value176";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value177"] = 177] = "Value177";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value178"] = 178] = "Value178";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value179"] = 179] = "Value179";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value180"] = 180] = "Value180";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value181"] = 181] = "Value181";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value182"] = 182] = "Value182";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value183"] = 183] = "Value183";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value184"] = 184] = "Value184";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value185"] = 185] = "Value185";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value186"] = 186] = "Value186";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value187"] = 187] = "Value187";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value188"] = 188] = "Value188";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value189"] = 189] = "Value189";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value190"] = 190] = "Value190";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value191"] = 191] = "Value191";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value192"] = 192] = "Value192";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value193"] = 193] = "Value193";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value194"] = 194] = "Value194";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value195"] = 195] = "Value195";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value196"] = 196] = "Value196";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value197"] = 197] = "Value197";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value198"] = 198] = "Value198";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value199"] = 199] = "Value199";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value200"] = 200] = "Value200";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value201"] = 201] = "Value201";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value202"] = 202] = "Value202";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value203"] = 203] = "Value203";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value204"] = 204] = "Value204";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value205"] = 205] = "Value205";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value206"] = 206] = "Value206";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value207"] = 207] = "Value207";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value208"] = 208] = "Value208";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value209"] = 209] = "Value209";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value210"] = 210] = "Value210";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value211"] = 211] = "Value211";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value212"] = 212] = "Value212";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value213"] = 213] = "Value213";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value214"] = 214] = "Value214";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value215"] = 215] = "Value215";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value216"] = 216] = "Value216";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value217"] = 217] = "Value217";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value218"] = 218] = "Value218";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value219"] = 219] = "Value219";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value220"] = 220] = "Value220";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value221"] = 221] = "Value221";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value222"] = 222] = "Value222";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value223"] = 223] = "Value223";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value224"] = 224] = "Value224";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value225"] = 225] = "Value225";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value226"] = 226] = "Value226";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value227"] = 227] = "Value227";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value228"] = 228] = "Value228";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value229"] = 229] = "Value229";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value230"] = 230] = "Value230";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value231"] = 231] = "Value231";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value232"] = 232] = "Value232";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value233"] = 233] = "Value233";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value234"] = 234] = "Value234";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value235"] = 235] = "Value235";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value236"] = 236] = "Value236";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value237"] = 237] = "Value237";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value238"] = 238] = "Value238";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value239"] = 239] = "Value239";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value240"] = 240] = "Value240";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value241"] = 241] = "Value241";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value242"] = 242] = "Value242";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value243"] = 243] = "Value243";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value244"] = 244] = "Value244";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value245"] = 245] = "Value245";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value246"] = 246] = "Value246";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value257"] = 257] = "Value257";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value258"] = 258] = "Value258";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value259"] = 259] = "Value259";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value260"] = 260] = "Value260";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value261"] = 261] = "Value261";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value262"] = 262] = "Value262";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value263"] = 263] = "Value263";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value270"] = 270] = "Value270";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value271"] = 271] = "Value271";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value272"] = 272] = "Value272";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value273"] = 273] = "Value273";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value274"] = 274] = "Value274";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value275"] = 275] = "Value275";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value276"] = 276] = "Value276";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value277"] = 277] = "Value277";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value278"] = 278] = "Value278";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value280"] = 280] = "Value280";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value281"] = 281] = "Value281";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value282"] = 282] = "Value282";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value283"] = 283] = "Value283";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value284"] = 284] = "Value284";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value285"] = 285] = "Value285";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value286"] = 286] = "Value286";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value287"] = 287] = "Value287";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value288"] = 288] = "Value288";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value289"] = 289] = "Value289";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value290"] = 290] = "Value290";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value291"] = 291] = "Value291";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value292"] = 292] = "Value292";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value293"] = 293] = "Value293";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value294"] = 294] = "Value294";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value295"] = 295] = "Value295";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value296"] = 296] = "Value296";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value297"] = 297] = "Value297";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value298"] = 298] = "Value298";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value299"] = 299] = "Value299";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value300"] = 300] = "Value300";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value301"] = 301] = "Value301";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value302"] = 302] = "Value302";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value303"] = 303] = "Value303";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value304"] = 304] = "Value304";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value305"] = 305] = "Value305";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value306"] = 306] = "Value306";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value307"] = 307] = "Value307";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value308"] = 308] = "Value308";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value309"] = 309] = "Value309";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value310"] = 310] = "Value310";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value311"] = 311] = "Value311";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value312"] = 312] = "Value312";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value313"] = 313] = "Value313";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value314"] = 314] = "Value314";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value315"] = 315] = "Value315";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value316"] = 316] = "Value316";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value317"] = 317] = "Value317";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value318"] = 318] = "Value318";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value319"] = 319] = "Value319";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value320"] = 320] = "Value320";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value321"] = 321] = "Value321";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value322"] = 322] = "Value322";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value323"] = 323] = "Value323";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value324"] = 324] = "Value324";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value325"] = 325] = "Value325";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value326"] = 326] = "Value326";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value327"] = 327] = "Value327";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value328"] = 328] = "Value328";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value329"] = 329] = "Value329";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value330"] = 330] = "Value330";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value331"] = 331] = "Value331";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value332"] = 332] = "Value332";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value333"] = 333] = "Value333";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value334"] = 334] = "Value334";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value335"] = 335] = "Value335";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value336"] = 336] = "Value336";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value337"] = 337] = "Value337";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value338"] = 338] = "Value338";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value339"] = 339] = "Value339";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value340"] = 340] = "Value340";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value341"] = 341] = "Value341";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value342"] = 342] = "Value342";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value343"] = 343] = "Value343";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value344"] = 344] = "Value344";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value345"] = 345] = "Value345";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value346"] = 346] = "Value346";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value347"] = 347] = "Value347";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value348"] = 348] = "Value348";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value349"] = 349] = "Value349";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value350"] = 350] = "Value350";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value351"] = 351] = "Value351";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value352"] = 352] = "Value352";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value353"] = 353] = "Value353";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value354"] = 354] = "Value354";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value355"] = 355] = "Value355";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value356"] = 356] = "Value356";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value357"] = 357] = "Value357";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value358"] = 358] = "Value358";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value359"] = 359] = "Value359";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value360"] = 360] = "Value360";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value361"] = 361] = "Value361";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value362"] = 362] = "Value362";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value363"] = 363] = "Value363";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value364"] = 364] = "Value364";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value365"] = 365] = "Value365";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value366"] = 366] = "Value366";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value367"] = 367] = "Value367";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value368"] = 368] = "Value368";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value369"] = 369] = "Value369";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value370"] = 370] = "Value370";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value371"] = 371] = "Value371";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value372"] = 372] = "Value372";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value373"] = 373] = "Value373";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value374"] = 374] = "Value374";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value375"] = 375] = "Value375";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value376"] = 376] = "Value376";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value377"] = 377] = "Value377";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value378"] = 378] = "Value378";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value379"] = 379] = "Value379";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value380"] = 380] = "Value380";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value381"] = 381] = "Value381";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value382"] = 382] = "Value382";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value383"] = 383] = "Value383";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value384"] = 384] = "Value384";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value385"] = 385] = "Value385";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value386"] = 386] = "Value386";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value387"] = 387] = "Value387";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value388"] = 388] = "Value388";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value389"] = 389] = "Value389";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value390"] = 390] = "Value390";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value391"] = 391] = "Value391";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value392"] = 392] = "Value392";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value393"] = 393] = "Value393";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value394"] = 394] = "Value394";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value395"] = 395] = "Value395";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value396"] = 396] = "Value396";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value397"] = 397] = "Value397";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value398"] = 398] = "Value398";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value399"] = 399] = "Value399";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value400"] = 400] = "Value400";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value401"] = 401] = "Value401";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value402"] = 402] = "Value402";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value403"] = 403] = "Value403";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value404"] = 404] = "Value404";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value405"] = 405] = "Value405";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value406"] = 406] = "Value406";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value407"] = 407] = "Value407";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value408"] = 408] = "Value408";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value409"] = 409] = "Value409";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value410"] = 410] = "Value410";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value411"] = 411] = "Value411";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value412"] = 412] = "Value412";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value413"] = 413] = "Value413";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value414"] = 414] = "Value414";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value415"] = 415] = "Value415";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value416"] = 416] = "Value416";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value417"] = 417] = "Value417";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value418"] = 418] = "Value418";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value419"] = 419] = "Value419";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value420"] = 420] = "Value420";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value421"] = 421] = "Value421";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value422"] = 422] = "Value422";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value423"] = 423] = "Value423";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value424"] = 424] = "Value424";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value425"] = 425] = "Value425";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value426"] = 426] = "Value426";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value427"] = 427] = "Value427";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value428"] = 428] = "Value428";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value429"] = 429] = "Value429";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value430"] = 430] = "Value430";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value431"] = 431] = "Value431";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value432"] = 432] = "Value432";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value433"] = 433] = "Value433";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value434"] = 434] = "Value434";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value435"] = 435] = "Value435";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value436"] = 436] = "Value436";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value437"] = 437] = "Value437";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value438"] = 438] = "Value438";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value439"] = 439] = "Value439";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value440"] = 440] = "Value440";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value441"] = 441] = "Value441";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value442"] = 442] = "Value442";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value443"] = 443] = "Value443";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value444"] = 444] = "Value444";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value445"] = 445] = "Value445";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value446"] = 446] = "Value446";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value447"] = 447] = "Value447";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value448"] = 448] = "Value448";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value449"] = 449] = "Value449";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value450"] = 450] = "Value450";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value451"] = 451] = "Value451";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value452"] = 452] = "Value452";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value453"] = 453] = "Value453";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value454"] = 454] = "Value454";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value455"] = 455] = "Value455";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value456"] = 456] = "Value456";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value457"] = 457] = "Value457";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value458"] = 458] = "Value458";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value459"] = 459] = "Value459";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value460"] = 460] = "Value460";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value461"] = 461] = "Value461";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value462"] = 462] = "Value462";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value463"] = 463] = "Value463";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value464"] = 464] = "Value464";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value465"] = 465] = "Value465";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value466"] = 466] = "Value466";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value467"] = 467] = "Value467";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value468"] = 468] = "Value468";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value469"] = 469] = "Value469";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value470"] = 470] = "Value470";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value471"] = 471] = "Value471";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value472"] = 472] = "Value472";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value473"] = 473] = "Value473";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value474"] = 474] = "Value474";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value475"] = 475] = "Value475";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value476"] = 476] = "Value476";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value477"] = 477] = "Value477";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value478"] = 478] = "Value478";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value479"] = 479] = "Value479";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value480"] = 480] = "Value480";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value481"] = 481] = "Value481";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value482"] = 482] = "Value482";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value483"] = 483] = "Value483";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value484"] = 484] = "Value484";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value485"] = 485] = "Value485";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value486"] = 486] = "Value486";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value487"] = 487] = "Value487";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value488"] = 488] = "Value488";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value489"] = 489] = "Value489";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value490"] = 490] = "Value490";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value491"] = 491] = "Value491";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value492"] = 492] = "Value492";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value493"] = 493] = "Value493";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value494"] = 494] = "Value494";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value495"] = 495] = "Value495";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value496"] = 496] = "Value496";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value497"] = 497] = "Value497";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value498"] = 498] = "Value498";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value499"] = 499] = "Value499";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value500"] = 500] = "Value500";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value501"] = 501] = "Value501";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value502"] = 502] = "Value502";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value503"] = 503] = "Value503";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value504"] = 504] = "Value504";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value505"] = 505] = "Value505";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value506"] = 506] = "Value506";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value507"] = 507] = "Value507";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value508"] = 508] = "Value508";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value509"] = 509] = "Value509";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value510"] = 510] = "Value510";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value511"] = 511] = "Value511";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value512"] = 512] = "Value512";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value513"] = 513] = "Value513";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value514"] = 514] = "Value514";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value515"] = 515] = "Value515";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value516"] = 516] = "Value516";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value517"] = 517] = "Value517";
    CommonEnumsErrorBaseCode[CommonEnumsErrorBaseCode["Value518"] = 518] = "Value518";
})(CommonEnumsErrorBaseCode || (CommonEnumsErrorBaseCode = {}));
export var CommonEnumsReportType;
(function (CommonEnumsReportType) {
    CommonEnumsReportType[CommonEnumsReportType["Value1"] = 1] = "Value1";
    CommonEnumsReportType[CommonEnumsReportType["Value2"] = 2] = "Value2";
    CommonEnumsReportType[CommonEnumsReportType["Value3"] = 3] = "Value3";
    CommonEnumsReportType[CommonEnumsReportType["Value4"] = 4] = "Value4";
    CommonEnumsReportType[CommonEnumsReportType["Value5"] = 5] = "Value5";
    CommonEnumsReportType[CommonEnumsReportType["Value6"] = 6] = "Value6";
})(CommonEnumsReportType || (CommonEnumsReportType = {}));
export var CommonEnumsWorkTimeType;
(function (CommonEnumsWorkTimeType) {
    CommonEnumsWorkTimeType[CommonEnumsWorkTimeType["Value0"] = 0] = "Value0";
    CommonEnumsWorkTimeType[CommonEnumsWorkTimeType["Value1"] = 1] = "Value1";
    CommonEnumsWorkTimeType[CommonEnumsWorkTimeType["Value2"] = 2] = "Value2";
    CommonEnumsWorkTimeType[CommonEnumsWorkTimeType["Value3"] = 3] = "Value3";
})(CommonEnumsWorkTimeType || (CommonEnumsWorkTimeType = {}));
export var CommonFeaturesEstonianLawFeatureEstonianLawParagraphs;
(function (CommonFeaturesEstonianLawFeatureEstonianLawParagraphs) {
    CommonFeaturesEstonianLawFeatureEstonianLawParagraphs[CommonFeaturesEstonianLawFeatureEstonianLawParagraphs["Value1"] = 1] = "Value1";
    CommonFeaturesEstonianLawFeatureEstonianLawParagraphs[CommonFeaturesEstonianLawFeatureEstonianLawParagraphs["Value2"] = 2] = "Value2";
    CommonFeaturesEstonianLawFeatureEstonianLawParagraphs[CommonFeaturesEstonianLawFeatureEstonianLawParagraphs["Value3"] = 3] = "Value3";
    CommonFeaturesEstonianLawFeatureEstonianLawParagraphs[CommonFeaturesEstonianLawFeatureEstonianLawParagraphs["Value4"] = 4] = "Value4";
    CommonFeaturesEstonianLawFeatureEstonianLawParagraphs[CommonFeaturesEstonianLawFeatureEstonianLawParagraphs["Value5"] = 5] = "Value5";
    CommonFeaturesEstonianLawFeatureEstonianLawParagraphs[CommonFeaturesEstonianLawFeatureEstonianLawParagraphs["Value6"] = 6] = "Value6";
    CommonFeaturesEstonianLawFeatureEstonianLawParagraphs[CommonFeaturesEstonianLawFeatureEstonianLawParagraphs["Value7"] = 7] = "Value7";
})(CommonFeaturesEstonianLawFeatureEstonianLawParagraphs || (CommonFeaturesEstonianLawFeatureEstonianLawParagraphs = {}));
export var CommonFeaturesPaginationFeatureOrderDirection;
(function (CommonFeaturesPaginationFeatureOrderDirection) {
    CommonFeaturesPaginationFeatureOrderDirection[CommonFeaturesPaginationFeatureOrderDirection["Value0"] = 0] = "Value0";
    CommonFeaturesPaginationFeatureOrderDirection[CommonFeaturesPaginationFeatureOrderDirection["Value1"] = 1] = "Value1";
})(CommonFeaturesPaginationFeatureOrderDirection || (CommonFeaturesPaginationFeatureOrderDirection = {}));
export var CommonFeaturesTableHistoryFeatureTableHistoryType;
(function (CommonFeaturesTableHistoryFeatureTableHistoryType) {
    CommonFeaturesTableHistoryFeatureTableHistoryType[CommonFeaturesTableHistoryFeatureTableHistoryType["Value1"] = 1] = "Value1";
    CommonFeaturesTableHistoryFeatureTableHistoryType[CommonFeaturesTableHistoryFeatureTableHistoryType["Value2"] = 2] = "Value2";
    CommonFeaturesTableHistoryFeatureTableHistoryType[CommonFeaturesTableHistoryFeatureTableHistoryType["Value3"] = 3] = "Value3";
})(CommonFeaturesTableHistoryFeatureTableHistoryType || (CommonFeaturesTableHistoryFeatureTableHistoryType = {}));
export var DTOOtherTimeRateSystemType;
(function (DTOOtherTimeRateSystemType) {
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value1"] = 1] = "Value1";
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value2"] = 2] = "Value2";
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value3"] = 3] = "Value3";
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value4"] = 4] = "Value4";
    DTOOtherTimeRateSystemType[DTOOtherTimeRateSystemType["Value5"] = 5] = "Value5";
})(DTOOtherTimeRateSystemType || (DTOOtherTimeRateSystemType = {}));
export var DalEventOverTimeLocation;
(function (DalEventOverTimeLocation) {
    DalEventOverTimeLocation[DalEventOverTimeLocation["Value0"] = 0] = "Value0";
    DalEventOverTimeLocation[DalEventOverTimeLocation["Value1"] = 1] = "Value1";
    DalEventOverTimeLocation[DalEventOverTimeLocation["Value2"] = 2] = "Value2";
    DalEventOverTimeLocation[DalEventOverTimeLocation["Value3"] = 3] = "Value3";
})(DalEventOverTimeLocation || (DalEventOverTimeLocation = {}));
export var DalEventType;
(function (DalEventType) {
    DalEventType[DalEventType["Value1"] = 1] = "Value1";
    DalEventType[DalEventType["Value2"] = 2] = "Value2";
})(DalEventType || (DalEventType = {}));
export var DalFormFilterOwnerType;
(function (DalFormFilterOwnerType) {
    DalFormFilterOwnerType[DalFormFilterOwnerType["Value1"] = 1] = "Value1";
    DalFormFilterOwnerType[DalFormFilterOwnerType["Value2"] = 2] = "Value2";
})(DalFormFilterOwnerType || (DalFormFilterOwnerType = {}));
export var DalJobEventCreatorType;
(function (DalJobEventCreatorType) {
    DalJobEventCreatorType[DalJobEventCreatorType["Value1"] = 1] = "Value1";
    DalJobEventCreatorType[DalJobEventCreatorType["Value2"] = 2] = "Value2";
    DalJobEventCreatorType[DalJobEventCreatorType["Value3"] = 3] = "Value3";
    DalJobEventCreatorType[DalJobEventCreatorType["Value4"] = 4] = "Value4";
    DalJobEventCreatorType[DalJobEventCreatorType["Value5"] = 5] = "Value5";
})(DalJobEventCreatorType || (DalJobEventCreatorType = {}));
export var DalLanguage;
(function (DalLanguage) {
    DalLanguage[DalLanguage["Value0"] = 0] = "Value0";
    DalLanguage[DalLanguage["Value1"] = 1] = "Value1";
    DalLanguage[DalLanguage["Value2"] = 2] = "Value2";
    DalLanguage[DalLanguage["Value3"] = 3] = "Value3";
    DalLanguage[DalLanguage["Value4"] = 4] = "Value4";
    DalLanguage[DalLanguage["Value5"] = 5] = "Value5";
    DalLanguage[DalLanguage["Value6"] = 6] = "Value6";
})(DalLanguage || (DalLanguage = {}));
export var DalLawLawId;
(function (DalLawLawId) {
    DalLawLawId[DalLawLawId["Value1"] = 1] = "Value1";
    DalLawLawId[DalLawLawId["Value2"] = 2] = "Value2";
})(DalLawLawId || (DalLawLawId = {}));
export var DalLunchCalculationType;
(function (DalLunchCalculationType) {
    DalLunchCalculationType[DalLunchCalculationType["Value1"] = 1] = "Value1";
    DalLunchCalculationType[DalLunchCalculationType["Value2"] = 2] = "Value2";
})(DalLunchCalculationType || (DalLunchCalculationType = {}));
export var DalPaymentTimeType;
(function (DalPaymentTimeType) {
    DalPaymentTimeType[DalPaymentTimeType["Value0"] = 0] = "Value0";
    DalPaymentTimeType[DalPaymentTimeType["Value1"] = 1] = "Value1";
    DalPaymentTimeType[DalPaymentTimeType["Value2"] = 2] = "Value2";
})(DalPaymentTimeType || (DalPaymentTimeType = {}));
export var DalProjectAssociationType;
(function (DalProjectAssociationType) {
    DalProjectAssociationType[DalProjectAssociationType["Value2"] = 2] = "Value2";
    DalProjectAssociationType[DalProjectAssociationType["Value4"] = 4] = "Value4";
})(DalProjectAssociationType || (DalProjectAssociationType = {}));
export var DalProjectStatus;
(function (DalProjectStatus) {
    DalProjectStatus[DalProjectStatus["Value0"] = 0] = "Value0";
    DalProjectStatus[DalProjectStatus["Value1"] = 1] = "Value1";
})(DalProjectStatus || (DalProjectStatus = {}));
export var DalRequestConfirmationType;
(function (DalRequestConfirmationType) {
    DalRequestConfirmationType[DalRequestConfirmationType["Value1"] = 1] = "Value1";
    DalRequestConfirmationType[DalRequestConfirmationType["Value2"] = 2] = "Value2";
})(DalRequestConfirmationType || (DalRequestConfirmationType = {}));
export var DalRequestStatusType;
(function (DalRequestStatusType) {
    DalRequestStatusType[DalRequestStatusType["Value1"] = 1] = "Value1";
    DalRequestStatusType[DalRequestStatusType["Value2"] = 2] = "Value2";
    DalRequestStatusType[DalRequestStatusType["Value3"] = 3] = "Value3";
    DalRequestStatusType[DalRequestStatusType["Value4"] = 4] = "Value4";
})(DalRequestStatusType || (DalRequestStatusType = {}));
export var DalRightType;
(function (DalRightType) {
    DalRightType[DalRightType["Value1"] = 1] = "Value1";
    DalRightType[DalRightType["Value2"] = 2] = "Value2";
    DalRightType[DalRightType["Value3"] = 3] = "Value3";
})(DalRightType || (DalRightType = {}));
export var DalRightsId;
(function (DalRightsId) {
    DalRightsId[DalRightsId["Value1"] = 1] = "Value1";
    DalRightsId[DalRightsId["Value2"] = 2] = "Value2";
    DalRightsId[DalRightsId["Value3"] = 3] = "Value3";
    DalRightsId[DalRightsId["Value4"] = 4] = "Value4";
    DalRightsId[DalRightsId["Value7"] = 7] = "Value7";
    DalRightsId[DalRightsId["Value8"] = 8] = "Value8";
    DalRightsId[DalRightsId["Value9"] = 9] = "Value9";
    DalRightsId[DalRightsId["Value10"] = 10] = "Value10";
    DalRightsId[DalRightsId["Value13"] = 13] = "Value13";
    DalRightsId[DalRightsId["Value14"] = 14] = "Value14";
    DalRightsId[DalRightsId["Value15"] = 15] = "Value15";
    DalRightsId[DalRightsId["Value16"] = 16] = "Value16";
    DalRightsId[DalRightsId["Value18"] = 18] = "Value18";
    DalRightsId[DalRightsId["Value20"] = 20] = "Value20";
    DalRightsId[DalRightsId["Value21"] = 21] = "Value21";
    DalRightsId[DalRightsId["Value22"] = 22] = "Value22";
    DalRightsId[DalRightsId["Value23"] = 23] = "Value23";
    DalRightsId[DalRightsId["Value24"] = 24] = "Value24";
    DalRightsId[DalRightsId["Value25"] = 25] = "Value25";
    DalRightsId[DalRightsId["Value26"] = 26] = "Value26";
    DalRightsId[DalRightsId["Value27"] = 27] = "Value27";
    DalRightsId[DalRightsId["Value28"] = 28] = "Value28";
    DalRightsId[DalRightsId["Value29"] = 29] = "Value29";
    DalRightsId[DalRightsId["Value30"] = 30] = "Value30";
    DalRightsId[DalRightsId["Value31"] = 31] = "Value31";
    DalRightsId[DalRightsId["Value32"] = 32] = "Value32";
    DalRightsId[DalRightsId["Value33"] = 33] = "Value33";
    DalRightsId[DalRightsId["Value34"] = 34] = "Value34";
    DalRightsId[DalRightsId["Value35"] = 35] = "Value35";
    DalRightsId[DalRightsId["Value36"] = 36] = "Value36";
    DalRightsId[DalRightsId["Value37"] = 37] = "Value37";
    DalRightsId[DalRightsId["Value38"] = 38] = "Value38";
    DalRightsId[DalRightsId["Value39"] = 39] = "Value39";
    DalRightsId[DalRightsId["Value40"] = 40] = "Value40";
    DalRightsId[DalRightsId["Value41"] = 41] = "Value41";
    DalRightsId[DalRightsId["Value42"] = 42] = "Value42";
    DalRightsId[DalRightsId["Value43"] = 43] = "Value43";
    DalRightsId[DalRightsId["Value44"] = 44] = "Value44";
    DalRightsId[DalRightsId["Value45"] = 45] = "Value45";
    DalRightsId[DalRightsId["Value46"] = 46] = "Value46";
    DalRightsId[DalRightsId["Value47"] = 47] = "Value47";
    DalRightsId[DalRightsId["Value48"] = 48] = "Value48";
    DalRightsId[DalRightsId["Value49"] = 49] = "Value49";
    DalRightsId[DalRightsId["Value50"] = 50] = "Value50";
    DalRightsId[DalRightsId["Value51"] = 51] = "Value51";
    DalRightsId[DalRightsId["Value52"] = 52] = "Value52";
    DalRightsId[DalRightsId["Value53"] = 53] = "Value53";
    DalRightsId[DalRightsId["Value54"] = 54] = "Value54";
    DalRightsId[DalRightsId["Value55"] = 55] = "Value55";
    DalRightsId[DalRightsId["Value56"] = 56] = "Value56";
    DalRightsId[DalRightsId["Value57"] = 57] = "Value57";
    DalRightsId[DalRightsId["Value58"] = 58] = "Value58";
    DalRightsId[DalRightsId["Value59"] = 59] = "Value59";
    DalRightsId[DalRightsId["Value60"] = 60] = "Value60";
    DalRightsId[DalRightsId["Value61"] = 61] = "Value61";
    DalRightsId[DalRightsId["Value62"] = 62] = "Value62";
    DalRightsId[DalRightsId["Value63"] = 63] = "Value63";
    DalRightsId[DalRightsId["Value64"] = 64] = "Value64";
    DalRightsId[DalRightsId["Value65"] = 65] = "Value65";
    DalRightsId[DalRightsId["Value66"] = 66] = "Value66";
    DalRightsId[DalRightsId["Value67"] = 67] = "Value67";
    DalRightsId[DalRightsId["Value68"] = 68] = "Value68";
    DalRightsId[DalRightsId["Value69"] = 69] = "Value69";
    DalRightsId[DalRightsId["Value70"] = 70] = "Value70";
    DalRightsId[DalRightsId["Value71"] = 71] = "Value71";
    DalRightsId[DalRightsId["Value72"] = 72] = "Value72";
    DalRightsId[DalRightsId["Value73"] = 73] = "Value73";
    DalRightsId[DalRightsId["Value74"] = 74] = "Value74";
    DalRightsId[DalRightsId["Value75"] = 75] = "Value75";
    DalRightsId[DalRightsId["Value76"] = 76] = "Value76";
    DalRightsId[DalRightsId["Value77"] = 77] = "Value77";
    DalRightsId[DalRightsId["Value78"] = 78] = "Value78";
    DalRightsId[DalRightsId["Value79"] = 79] = "Value79";
    DalRightsId[DalRightsId["Value80"] = 80] = "Value80";
    DalRightsId[DalRightsId["Value81"] = 81] = "Value81";
    DalRightsId[DalRightsId["Value82"] = 82] = "Value82";
    DalRightsId[DalRightsId["Value83"] = 83] = "Value83";
    DalRightsId[DalRightsId["Value84"] = 84] = "Value84";
    DalRightsId[DalRightsId["Value85"] = 85] = "Value85";
    DalRightsId[DalRightsId["Value86"] = 86] = "Value86";
    DalRightsId[DalRightsId["Value87"] = 87] = "Value87";
    DalRightsId[DalRightsId["Value88"] = 88] = "Value88";
    DalRightsId[DalRightsId["Value89"] = 89] = "Value89";
    DalRightsId[DalRightsId["Value90"] = 90] = "Value90";
    DalRightsId[DalRightsId["Value91"] = 91] = "Value91";
    DalRightsId[DalRightsId["Value92"] = 92] = "Value92";
    DalRightsId[DalRightsId["Value93"] = 93] = "Value93";
})(DalRightsId || (DalRightsId = {}));
export var DalWorkDayEventType;
(function (DalWorkDayEventType) {
    DalWorkDayEventType[DalWorkDayEventType["Value1"] = 1] = "Value1";
    DalWorkDayEventType[DalWorkDayEventType["Value2"] = 2] = "Value2";
    DalWorkDayEventType[DalWorkDayEventType["Value3"] = 3] = "Value3";
})(DalWorkDayEventType || (DalWorkDayEventType = {}));
export var ConfKey;
(function (ConfKey) {
    ConfKey["AbsenceImportDeleteOverlappingActualJob"] = "AbsenceImport.DeleteOverlappingActualJob";
    ConfKey["AbsenceImportDeleteOverlappingManualAbsence"] = "AbsenceImport.DeleteOverlappingManualAbsence";
    ConfKey["NonWorkColorStart"] = "nonWorkColorStart";
    ConfKey["NonWorkColorEnd"] = "nonWorkColorEnd";
    ConfKey["NonWorkFontColor"] = "nonWorkFontColor";
    ConfKey["LogPath"] = "logPath";
    ConfKey["ReportPath"] = "reportPath";
    ConfKey["MailSenderIp"] = "mailSenderIp";
    ConfKey["MailSenderPort"] = "mailSenderPort";
    ConfKey["ProfilePictures"] = "profilePictures";
    ConfKey["PictureHight"] = "pictureHight";
    ConfKey["PictureWidth"] = "pictureWidth";
    ConfKey["PictureSmallHight"] = "pictureSmallHight";
    ConfKey["PictureSmallWidth"] = "pictureSmallWidth";
    ConfKey["CompanyName"] = "CompanyName";
    ConfKey["JobProfileAudios"] = "jobProfileAudios";
    ConfKey["LogOutTIme"] = "logOutTIme";
    ConfKey["NationalLanguage"] = "nationalLanguage";
    ConfKey["JobEndSound"] = "JobEndSound";
    ConfKey["ApiVersion"] = "apiVersion";
    ConfKey["AmsShiftForRegularJobWithPaidLunch"] = "AMS.ShiftForRegularJobWithPaidLunch";
    ConfKey["AmsShiftForRegularJobWithUnpaidLunch"] = "AMS.ShiftForRegularJobWithUnpaidLunch";
    ConfKey["AmsShiftForOffScheduledJobWithPaidLunch"] = "AMS.ShiftForOffScheduledJobWithPaidLunch";
    ConfKey["AmsShiftForOffScheduledJobWithUnpaidLunch"] = "AMS.ShiftForOffScheduledJobWithUnpaidLunch";
    ConfKey["AmsImportJob"] = "AMS.ImportJob";
    ConfKey["AmsImportAbsence"] = "AMS.ImportAbsence";
    ConfKey["MainReportShowOld"] = "MainReport.ShowOld";
    ConfKey["MaximumLunchLength"] = "MaximumLunchLength";
    ConfKey["PlannerPolicy"] = "PlannerPolicy";
    ConfKey["AdvancedPlannerEnabled"] = "AdvancedPlannerEnabled";
})(ConfKey || (ConfKey = {}));
export var WorkEffortTypes;
(function (WorkEffortTypes) {
    WorkEffortTypes[WorkEffortTypes["WorkTime"] = 1] = "WorkTime";
    WorkEffortTypes[WorkEffortTypes["Lunch"] = 2] = "Lunch";
    WorkEffortTypes[WorkEffortTypes["Break"] = 3] = "Break";
    WorkEffortTypes[WorkEffortTypes["Vacation"] = 4] = "Vacation";
    WorkEffortTypes[WorkEffortTypes["Sickness"] = 5] = "Sickness";
    WorkEffortTypes[WorkEffortTypes["BusinessTrip"] = 6] = "BusinessTrip";
})(WorkEffortTypes || (WorkEffortTypes = {}));
